// Lightweight client-side toast injector. Server-rendered flash
// toasts use the @components.Toast templ in layout.templ; this
// helper is for JS-driven success/error/info messages after a fetch.
//
// Entry + exit reuse the same animate-toast-in / animate-toast-out
// keyframes the server-rendered Toast uses, so JS-issued and templ-
// issued toasts feel like the same component. The dismiss timer
// pauses while the tab is hidden so a confirmation isn't gone by
// the time the user returns.

const TONES = {
  success: "border-emerald-200 text-emerald-700 bg-emerald-50",
  error: "border-red-200 text-red-700 bg-red-50",
  info: "border-orange-100 text-ink-700 bg-warm-50",
};

const DISMISS_AFTER_MS = 2200;
const EXIT_ANIMATION_MS = 300;

export function showToast(message, variant) {
  const container = document.getElementById("toast-container");
  if (!container) return;

  const tone = TONES[variant] || TONES.success;
  const toast = document.createElement("div");
  toast.className = `pointer-events-auto rounded-xl border ${tone} shadow-[var(--shadow-warm-md)] px-4 py-2.5 text-sm font-medium animate-toast-in`;
  toast.textContent = message;
  container.appendChild(toast);

  let remaining = DISMISS_AFTER_MS;
  let startedAt = Date.now();
  let timer = null;

  function dismiss() {
    document.removeEventListener("visibilitychange", onVisibility);
    toast.classList.remove("animate-toast-in");
    toast.classList.add("animate-toast-out");
    setTimeout(() => toast.remove(), EXIT_ANIMATION_MS);
  }

  function startTimer() {
    startedAt = Date.now();
    timer = setTimeout(dismiss, remaining);
  }

  function pauseTimer() {
    if (timer == null) return;
    clearTimeout(timer);
    timer = null;
    remaining -= Date.now() - startedAt;
  }

  function onVisibility() {
    if (document.visibilityState === "hidden") {
      pauseTimer();
    } else if (timer == null && remaining > 0) {
      startTimer();
    }
  }

  document.addEventListener("visibilitychange", onVisibility);
  startTimer();
}
